import API from 'utils/api';
import { onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';
import { message } from 'antd';

export const baseURI = 'tramites/catalogos-speedway/';

/**
 * GET Speedways
 * param {object} params
 * @returns {Promise<object[]>}
 */
export const getSpeedways = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Speedways
 * param {id} number
 * @returns {Promise<object>}
 */
export const getSpeedway = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Speedway
 * param {object} values
 * @returns {Promise<object>}
 */
export const postSpeedway = async (params) => {
  try {
    const response = await API.post(baseURI, { params });
    message.info(response.detail || 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Speedway
 * param {id} number
 * param {object} values
 * @returns {Promise<object>}
 */
export const patchSpeedway = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    message.info(response.detail || 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return false;
};
